import { render } from "./ProductTableAuctionHistory.vue?vue&type=template&id=623d81fa&scoped=true"
import script from "./ProductTableAuctionHistory.vue?vue&type=script&lang=js"
export * from "./ProductTableAuctionHistory.vue?vue&type=script&lang=js"

import "./ProductTableAuctionHistory.vue?vue&type=style&index=0&id=623d81fa&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623d81fa"]])

export default __exports__